import {isNil} from 'ramda';

import {getPdfExportData} from '../api/getPdfExportData';
import type {GridPdfExportCallback} from '../types/GridPdfExportCallback';
import type {GridPdfExportContext} from '../types/GridPdfExportContext';
import type {GridPdfExportRequest} from '../types/GridPdfExportRequest';
import {prepareGridPdfExport} from './prepareGridPdfExport';

/** A dialog-owned job. Retry loading until preparation succeeds, then reuse the prepared values. */
export function createGridPdfExportJob(
  request: GridPdfExportRequest,
  onPdfExportCallback: GridPdfExportCallback
) {
  let prepared: GridPdfExportContext | undefined;
  return async (signal: AbortSignal) => {
    signal.throwIfAborted();
    if (isNil(prepared)) {
      const rows = await getPdfExportData(request, signal);
      signal.throwIfAborted();
      prepared = prepareGridPdfExport(request, rows);
    }
    return onPdfExportCallback(structuredClone(prepared), signal);
  };
}
